import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import { AppBarComponent } from '@syncfusion/ej2-react-navigations';
import React from 'react';
import useWindowSize from '../hooks/useWindowSize';

export default function TitleBar({ data }) {
    const { name, tenant } = data;
    const { width } = useWindowSize();
    const fontSize = width >= 1024 ? '20px' : '12px';

    const openInNewTab = (url) => {
        window.open(url, '_blank', 'noreferrer');
    };

    return (

        <div>
            <AppBarComponent colorMode="Primary" cssClass='e-appbar' style={tenant && tenant.primaryColour ? { background: tenant.primaryColour } : { background: `#2A8BFF`}}>
                <span className="text-white mx-2" style={{ fontSize: fontSize }}>{name}</span>
                <div className="e-appbar-spacer"></div>
                {tenant && (tenant.domainUrl !== '' ? (
                    <ButtonComponent onClick={() => openInNewTab(tenant.domainUrl)} style={{ fontSize: fontSize }} cssClass='e-inherit text-white'>{(width > 300 ? tenant.name : tenant.shortName)}</ButtonComponent>) : <span style={{ textTransform: 'uppercase', fontSize: fontSize }} className="mx-2" >{tenant.name}</span>)}
            </AppBarComponent>


        </div>
    );
}